import {useContext, useState, useEffect} from "react";

import RefreshContext from "../RefreshContext";
import TransactionsTable from "./TransactionsTable";
import withParams from "../lib/withParams";
import EditPayee from "./EditPayee";
import apiClient from "../lib/apiClient";
import TransactionOverlay from "./TransactionOverlay";

export default function Transactions({limit, dataViewId, accountId}) {
  const [transactions, setTransactions] = useState(null);
  const [transaction, setTransaction] = useState(null);
  const [payee, setPayee] = useState(null);
  const [sortOrder, setSortOrder] = useState("date");
  const {refreshKey} = useContext(RefreshContext);
  const [uncategorizedOnly, setUncategorizedOnly] = useState(false);
  const [search, setSearch] = useState("");

  let url = withParams("/api/transactions", {dataViewId, accountId, limit});
  if (uncategorizedOnly) {
    url += "&uncategorized=1";
  }
  if (search && search.length > 0) {
    url += `&search=${search}`;
  }
  if (sortOrder) {
    url += `&order=${sortOrder}`;
  }

  useEffect(() => {
    const fetchTransactions = async () => {
      const {data} = await apiClient.get(url);

      setTransactions(data);
    };
    fetchTransactions();
  }, [refreshKey, url]);


  useEffect(() => {
    setTransactions(null);
  }, [refreshKey, uncategorizedOnly]);

  // todo remove this if not needed
  async function _onClickPayee(payee_id) {
    const response = await fetch(`/api/payees/${payee_id}`);
    const data = await response.json();
    setPayee(data);
  }

  let columns = ["account_name", "category", "payee_name"];
  if (uncategorizedOnly) {
    columns = ["account_name", "description"];
  }
  return (

    <div className={"row p-3  w-100"}>
      <form className={"d-flex align-items-baseline container-fluid border-secondary p-2"}>
        <input type="radio"
               className="form-radio-input"
               checked={uncategorizedOnly}
               onChange={() => setUncategorizedOnly(true)}/>
        <label className={"form-label text-nowrap px-2"}
               onClick={() => setUncategorizedOnly(true)}>
          Uncategorized
        </label>
        <input type="radio"
               className="form-radio-input ms-1"
               checked={!uncategorizedOnly}
               onChange={() => setUncategorizedOnly(false)}/>
        <label className={"form-label text-nowrap px-2"}
               onClick={() => setUncategorizedOnly(false)}>
          All
        </label>

        <input type="search"
               className={"ms-2 search form-control"}
               placeholder={"Search"}
               onKeyUp={(e) => setSearch(e.target.value)}/>
      </form>

      <div className="p-4 pt-2">
        {transactions && <>
          <TransactionsTable transactions={transactions}
                           columns={columns}
                           onClickDate={() => setSortOrder("date")}
                           onClickAmount={() => setSortOrder("amount")}
                           onClickTransaction={setTransaction}
                           sortColumn={sortOrder}
                           with_cents/>
        {payee && <EditPayee payee={payee} onHide={() => setPayee(null)}/>}
        {transaction && <TransactionOverlay transactionId={transaction.id} onClose={() => setTransaction(null)}/>}
        </>
      }
      </div>
    </div>
  );
}

